export const ClientsTrackingPermissions = {
  ViewClientTracking: {
    permissionsId: "63528373-fe7a-4805-b6e8-08dd8b9e8c29",
    permissionsName: "View Client Tracking",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewGeneralInquiry: {
    permissionsId: "6fe7cb6e-ca09-4365-b9fc-0a95ee8860ba",
    permissionsName: "View General Inquiry",
    description: null,
    componentsId: null,
    components: null,
  },
  ExportGeneralInquiry: {
    permissionsId: "346c4e43-b663-402b-b96c-1639d35a5847",
    permissionsName: "Export General Inquiry",
    description: null,
    componentsId: null,
    components: null,
  },
  AddActivityForClientTracking: {
    permissionsId: "0b1ff15a-7f46-4d31-942a-3eb0087fddb7",
    permissionsName: "add Activity for client tracking",
    description: null,
    componentsId: null,
    components: null,
  },
  AddReceiptDocumentForClientTracking: {
    permissionsId: "273ed461-189e-4791-8a2d-48d6ae9c091a",
    permissionsName: "Add Receipt Document for client tracking",
    description: null,
    componentsId: null,
    components: null,
  },
  CreateLeadForGeneralInquiry: {
    permissionsId: "074ece6d-a60c-402c-b9e5-65f23ee20d9b",
    permissionsName: "Create Lead for General Inquiry",
    description: null,
    componentsId: null,
    components: null,
  },
  AddActivityForGeneralInquiry: {
    permissionsId: "8ef12e99-bdaa-470d-9d63-7b8a9ca20dd6",
    permissionsName: "add Activity for General Inquiry",
    description: null,
    componentsId: null,
    components: null,
  },
  UpdateLeadSourc: {
    permissionsId: "e57a15e2-7480-4b4c-9d79-7fe46aaaf153",
    permissionsName: "Update Lead Source",
    description: null,
    componentsId: null,
    components: null,
  },
  OpenClientTracking: {
    permissionsId: "f410d865-210d-4b90-8c64-8b6126aa9ea8",
    permissionsName: "Open client tracking",
    description: null,
    componentsId: null,
    components: null,
  },
  UpdateInquiryStatus: {
    permissionsId: "4c2edec4-67e0-4d76-9296-d90b505b8c6c",
    permissionsName: "Update Inquiry Status",
    description: null,
    componentsId: null,
    components: null,
  },
  CreateLeadForClientTracking: {
    permissionsId: "9b8909bd-2a5e-4ec3-b0ec-dab487e02d1f",
    permissionsName: "Create Lead for client tracking",
    description: null,
    componentsId: null,
    components: null,
  },
};
